import React from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin, {DateClickArg, EventResizeDoneArg} from '@fullcalendar/interaction';
import {DateSelectArg, DatesSetArg, EventClickArg, EventDropArg, EventInput, LocaleInput} from '@fullcalendar/common';
import '@fullcalendar/common/main.css';
import '@fullcalendar/daygrid/main.css';
import '@fullcalendar/timegrid/main.css';
import '@fullcalendar/list/main.css';

// Agenda dos processos (#480058): FullCalendar 5 em portugues. Os nomes de mes
// e dia vem do Intl do navegador pelo codigo pt-br; os textos ficam aqui.
const PT_BR: LocaleInput = {
    code: 'pt-br',
    buttonText: {prev: 'Anterior', next: 'Próximo', today: 'Hoje', month: 'Mês', week: 'Semana', day: 'Dia', list: 'Lista'},
    weekText: 'Sm',
    allDayText: 'Dia todo',
    moreLinkText: (n: number) => `+${n} mais`,
    noEventsText: 'Nada neste período',
};

/** Cores por tipo de evento e para os prazos de item. */
export const COR_EVENTO: {[tipo: number]: string} = {
    1: '#321fdb', // kick-off
    2: '#0e7490', // reuniao
    3: '#7c3aed', // treinamento
    4: '#b45309', // entrega
    5: '#16a34a', // go-live
    9: '#6b7280', // outro
};
export const COR_PRAZO = '#94a3b8';
export const COR_PRAZO_ATRASADO = '#dc2626';

interface Props {
    eventos: EventInput[],
    visao?: string,
    altura?: string | number,
    aoClicar?: (arg: EventClickArg) => void,
    aoClicarDia?: (arg: DateClickArg) => void,
    aoMudarPeriodo?: (arg: DatesSetArg) => void,
    /** Arrastou um evento (o que pode arrastar vem em cada evento: startEditable/durationEditable). */
    aoMover?: (arg: EventDropArg) => void,
    /** Esticou ou encolheu um evento. */
    aoRedimensionar?: (arg: EventResizeDoneArg) => void,
    /** Selecionou um intervalo (na semana, um horario) para agendar. */
    aoSelecionar?: (arg: DateSelectArg) => void,
}

const Calendario = ({eventos, visao = 'dayGridMonth', altura = '100%', aoClicar, aoClicarDia, aoMudarPeriodo, aoMover, aoRedimensionar, aoSelecionar}: Props) => (
    <div className="pr-calendario">
        <FullCalendar
            plugins={[dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin]}
            initialView={visao}
            locale={PT_BR}
            firstDay={0}
            height={altura}
            headerToolbar={{left: 'prev,next today', center: 'title', right: 'dayGridMonth,timeGridWeek,listMonth'}}
            views={{listMonth: {buttonText: 'Lista'}}}
            dayMaxEvents={4}
            nowIndicator
            weekends
            slotMinTime="07:00:00"
            slotMaxTime="21:00:00"
            eventTimeFormat={{hour: '2-digit', minute: '2-digit', hour12: false}}
            events={eventos}
            eventClick={aoClicar}
            dateClick={aoClicarDia}
            datesSet={aoMudarPeriodo}
            editable={false}
            eventDrop={aoMover}
            eventResize={aoRedimensionar}
            selectable={!!aoSelecionar}
            selectMirror
            select={aoSelecionar}
            snapDuration="00:15:00"
        />
    </div>
);

export default Calendario;
